import React, { Component } from 'react';
import OurStory from '../../client/components/ourStory';
import Header from '../../client/shared-ui/header/index';

class Story extends Component {
  render () {
    return (
      <><Header /><OurStory /></>
    );
  }
}

export default Story;